<template>
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6571 2.37157L8.8 9.22871C8.57143 9.45728 8.34286 9.57157 8 9.57157C7.65714 9.57157 7.42857 9.45728 7.2 9.22871L0.342857 2.37157C-0.114286 1.91443 -0.114286 1.22871 0.342857 0.771568C0.8 0.314425 1.48571 0.314425 1.94286 0.771568L8 6.82871L14.0571 0.771568C14.5143 0.314425 15.2 0.314425 15.6571 0.771568C16.1143 1.22871 16.1143 1.91443 15.6571 2.37157Z"
      fill="#1F2C40"
    />
  </svg>
</template>

<script>
export default {
  name: "ChevronDownIcon",
};
</script>

<style scoped></style>
